export const Logo = ({ className = 'h-8 w-auto', withWordmark = true }) => (
    <a href="#top" data-testid="nav-logo" className="group flex items-center gap-3">
        <svg
            viewBox="0 0 64 64"
            className={className}
            aria-label="Bros On Board"
            role="img"
        >
            {/* B monogram letterform */}
            <path
                d="M14 16 L14 48 M14 16 L26 16 Q33 16 33 23 Q33 30 26 30 L14 30 M14 30 L28 30 Q35 30 35 38 Q35 48 28 48 L14 48"
                stroke="currentColor"
                strokeWidth="2.4"
                strokeLinecap="square"
                fill="none"
            />
            {/* O - aperture dot (represents the lens) */}
            <circle
                cx="47"
                cy="32"
                r="9"
                stroke="#E5C07B"
                strokeWidth="2.2"
                fill="none"
                className="origin-center transition-transform duration-700 group-hover:rotate-180"
                style={{ transformBox: 'fill-box' }}
            />
            <circle cx="47" cy="32" r="2.4" fill="#E5C07B" />
        </svg>
        {withWordmark && (
            <span className="font-serif text-bone text-lg tracking-tight whitespace-nowrap">
                Bros<span className="italic text-gold mx-1.5">on</span>Board
            </span>
        )}
    </a>
);
